// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__S4SQB","modalCancelBtn":"style_modalCancelBtn__holF3"};